module.exports = __webpack_public_path__ + "img/icon_12.6440a0de.png";